module.exports = __webpack_public_path__ + "static/media/ivertical.c0c9324e.png";